<div class="downloads-page">
  <div class="container-fluid clearfix">
    <div class="d-flex flex-wrap justify-content-center">
      <mat-card
        class="card-style"
        [hidden]="isConfirmed"
        style="max-width: 400px"
      >
        <div class="row center-container">
          <div class="col-sm-12">
            <div class="row" style="max-width: 350px">
              <div class="col-sm-12">
                <label id="options-radio-group-label">
                  <h4 class="downloads-page">Download</h4>
                </label>
                <mat-radio-group
                  aria-labelledby="options-radio-group-label"
                  class="options-radio-format-group"
                  [(ngModel)]="formatOption"
                >
                  <mat-radio-button
                    color="warn"
                    style="margin-top: 10px"
                    *ngFor="let option of formatOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <div class="col-sm-auto p-0">
                  <app-single-dropbox
                    class="single-dropbox"
                    [showStationBadge]="true"
                    [isDisabled]="disableStationsDropBox"
                    [allowMultiple]="false"
                    cssClassToApply="dropbox-w-300 single-dropbox-custom"
                    popupPositionLeft="44"
                    [(ngModel)]="stations"
                    placeholder="Select Station"
                    placeholderLabel="Find a station..."
                    noEntriesFoundLabel="No station found"
                    (selectionChanged)="selectStation($event)"
                    #stationMulti
                  >
                  </app-single-dropbox>
                </div>
                <div class="col-sm-auto p-0">
                  <div class="source">
                    <app-single-dropbox
                      class="single-dropbox"
                      [isDisabled]="isStationSourcesDropboxDisable"
                      [allowMultiple]="false"
                      cssClassToApply="dropbox-w-300 single-dropbox-custom"
                      popupPositionLeft="44"
                      [(ngModel)]="stationSourceSelected"
                      placeholder="Select Source"
                      placeholderLabel="Find a source..."
                      noEntriesFoundLabel="No source found"
                      (selectionChanged)="selectStationSource($event)"
                      #stationSourceMulti
                    >
                    </app-single-dropbox>
                  </div>
                </div>
              </div>
            </div>           
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <mat-label style="font-size: 11px" #matLabel [matTooltip]="daysTooltip()"
                  >Start Date & Time <mat-icon class ="icon-display">info</mat-icon></mat-label
                >
                <ng2-flatpickr
                  #startPicker
                  [config]="startOptions"
                  [formControl]="dateTimeCtrl"
                >
                </ng2-flatpickr>
              </div>
            </div>
            <mat-form-field
            style="min-width: 320px; margin-top: 15px"
            appearance="standard"
          >
            <mat-label>Timezone</mat-label>
            <mat-select
              data-testid="select-timezone"
              [(ngModel)]="selectedTimezoneTypeOption"
              name="timezoneTypeOptions"
            >
              <mat-option
                *ngFor="let timezoneType of timezoneTypeOptions"
                [value]="timezoneType"
                (click) = "selectTimezone(timezoneType)"
              >
                {{ timezoneType.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <h4>
                  Duration
                  <span class="slider" [hidden]="!formatOption"
                    >(Max {{ sliderMax }} min)</span
                  >
                </h4>
              </div>
            </div>
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-9 float-left">
                <mat-slider
                  style="width: 245px"
                  color="warn"
                  [max]="sliderMax"
                  min="0"
                  step="1"
                  thumbLabel="true"
                  [(ngModel)]="sliderValue"
                >
                </mat-slider>
              </div>
              <div class="col-sm-3 float-right">
                <mat-form-field class="value">
                  <input
                    #sliderInputBox
                    matInput
                    type="number"
                    min="0"
                    [(ngModel)]="sliderValue"
                    [max]="sliderMax"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row" style="max-width: 350px; margin-top: 15px">
              <div class="col-sm-12">
                <label id="options-radio-group-label">
                  <h4 class="downloads-page">Delivery Method</h4>
                </label>
                <mat-radio-group
                  aria-labelledby="options-radio-group-label"
                  class="options-radio-format-group"
                  [(ngModel)]="methodOption"
                  (change)="optionDownload()"
                >
                  <mat-radio-button
                    color="warn"
                    style="margin-top: 10px"
                    *ngFor="let option of methodOptions"
                    [value]="option"
                  >
                    {{ option.name }}
                  </mat-radio-button>
                </mat-radio-group>
                <mat-form-field
                  *ngIf="methodOption.value === DownloadMethodEnum.EMAIL"
                  style="width: 315px"
                >
                  <input
                    data-testid="email-field"
                    required
                    #emailBox
                    matInput
                    placeholder="Email Address"
                    aria-label="Email"
                    [formControl]="emailCtrl"
                  />
                  <mat-hint align="end"
                    >Not more then 60 characters long.</mat-hint
                  >
                  <mat-error
                    *ngIf="
                      emailCtrl.hasError('email') &&
                      !emailCtrl.hasError('required')
                    "
                  >
                    Please enter a valid email address
                  </mat-error>
                  <mat-error *ngIf="emailCtrl.hasError('required')">
                    Email is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="emailCtrl.hasError('maxlength')"
                    >You have more than 60 characters.
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row" style="margin-top: 35px">
              <div class="col-sm-12 p-0">
                <button mat-button class="float-left" (click)="clear()">
                  CLEAR FIELDS
                </button>
                <button
                  data-testid="submit-button"
                  [class.primary-button-disabled]="disableSubmitButton"
                  [class.primary-button]="!disableSubmitButton"
                  [disabled]="disableSubmitButton"
                  mat-button
                  (click)="submit()"
                  class="float-right no-outline"
                  style="margin-right: 15px"
                >
                  SUBMIT
                </button>
              </div>
            </div>
          </div>
        </div>
      </mat-card>

      <mat-card
        class="card-style"
        [hidden]="!isConfirmed"
        style="max-width: 400px"
      >
        <div class="row center-container">
          <div class="col-sm-12">
            <p
              style="max-width: 500px; text-align: center"
              *ngIf="isSuccess"
              data-testid="successful-message"
            >
              Thank you! You’ve requested
              <span [innerHTML]="displayAudioFormatName"></span> from
              <b>{{ displayedStationName }} ({{ displayStationSourceName }})</b>
              on <b>{{ displayedDateTime }} ({{displayedTimeZone }})</b> for a duration of
              <b>{{ sliderValue }}</b> minutes.
              <ng-container [ngSwitch]="methodOption.value">
                <ng-container *ngSwitchCase="DownloadMethodEnum.EMAIL">
                  You’ll receive an email when your files are ready to download.
                </ng-container>
                <ng-container *ngSwitchCase="DownloadMethodEnum.DOWNLOAD">
                  Your file will be available shortly on Downloads.
                </ng-container>
                <ng-container *ngSwitchDefault></ng-container>
              </ng-container>
            </p>
            <p style="max-width: 500px; text-align: center" *ngIf="!isSuccess">
              Sorry, we didn’t have results to send you for your request of
              <span [innerHTML]="displayAudioFormatName"></span> for
              <b>{{ displayedStationName }} ({{ displayStationSourceName }})</b>
              for <b>{{ displayedDateTime }} ({{displayedTimeZone }})</b
              >, please try a different request.
            </p>
          </div>
        </div>
        <div class="row center-container button-row">
          <div>
            <button mat-button (click)="backToDownload()">
              Back to Downloads
            </button>
          </div>
          <a routerLink="/search">
            <button mat-button data-testid="back-search-button">
              Back to Search
            </button>
          </a>
        </div>
        <button mat-icon-button class="close-button" (click)="backToDownload()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-card>

      <mat-card
        class="card-style"
        style="max-width: 685px"
        [hidden]="isConfirmed"
      >
        <div class="header-available-download">
          <h2>Available Downloads</h2>
          <div style="margin: auto 20px; min-width: 175px">
            <mat-slide-toggle
              [checked]="true"
              (change)="updateDownloadListTimezone($event.checked)"
            >
              {{ timezoneTypeToString(downloadListTimezoneType) }}
            </mat-slide-toggle>
          </div>
          <div>
            <button
              color="primary"
              data-testid="refresh-button"
              mat-button
              (click)="getDownloads()"
              [disableRipple]="true"
            >
              Refresh
              <mat-icon aria-hidden="false" aria-label="Refresh icon"
                >sync</mat-icon
              >
            </button>
          </div>
        </div>
        <div class="table-container">
          <table
            mat-table
            [dataSource]="downloadList"
            data-testid="download-table"
            *ngIf="downloadList && downloadList.length; else noDownloads"
          >

            <!-- Station Column -->
            <ng-container matColumnDef="stationName">
              <th mat-header-cell *matHeaderCellDef class="header">Station</th>
              <td mat-cell *matCellDef="let download">
                {{ download.stationName }}
              </td>
            </ng-container>

            <!-- Source Column -->
            <ng-container matColumnDef="stationSource">
              <th mat-header-cell *matHeaderCellDef class="header">Source</th>
              <td mat-cell *matCellDef="let download">
                {{ download.stationSource.name }}
              </td>
            </ng-container>

            <!-- Start Time Column -->
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef class="header">
                Start Time
              </th>
              <td mat-cell *matCellDef="let download">
                {{ download.startDateString }}
              </td>
            </ng-container>

            <!-- End Time Column -->
            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef class="header">End Time</th>
              <td mat-cell *matCellDef="let download">
                {{ download.endDateString }}
              </td>
            </ng-container>

            <!-- Duration Column -->
            <ng-container matColumnDef="durationInSeconds">
              <th mat-header-cell *matHeaderCellDef class="header">Duration</th>
              <td mat-cell *matCellDef="let download">
                {{ download.durationInSeconds | formatFancyTime }}
              </td>
            </ng-container>

            <!-- Download Column -->
            <ng-container matColumnDef="downloadLink">
              <th mat-header-cell *matHeaderCellDef class="header"></th>
              <td mat-cell *matCellDef="let download">
                <div *ngIf="download.downloadLink; else withoutLink">
                  <button
                    mat-stroked-button
                    *ngIf="download.downloadLink != 'ERROR'; else downloadError"
                    (click)="downloadFile(download.downloadLink)"
                  >
                    Download
                  </button>
              </div>
              </td>
              <ng-template #withoutLink>
                Processing...
                <mat-progress-bar
                  data-testid="processing"
                  mode="indeterminate"
                ></mat-progress-bar>
              </ng-template>

              <ng-template #downloadError>
                <div style="color: red">
                  Failed
                </div>
              </ng-template>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>

          <ng-template class="no-downloads" #noDownloads>
            <p>No available downloads</p>
          </ng-template>
        </div>
      </mat-card>
    </div>
  </div>
</div>
